import React from "react";
import twotourevents1 from "./images/twotourevents1.jpg";
import twotourevents2 from "./images/twotourevents2.jpg";
import twotourevents3 from "./images/twotourevents3.jpg";

export default function () {
return (
<div>
    <section
    id="tour-events-3"
    className=" container   mx-auto row mt-5 mb-5 ">
    <h2 className="mb-5 mt-5 ">Tour Events for You</h2>
    <div className="col-lg-4 col-md-6 ">
        <div className="card border-0  ">
        <img
            src={twotourevents1}
            className="card-img-top"
            alt="..."
        />
        <div className="card-body d-flex  ">
            <span className="">
            {" "}
            <i className="fa-regular fa-calendar-days text-success" />{" "}
            SEPTEMBER 19,2022{" "}
            </span>
        </div>
        <h3 className="post-title">
            <a href="#">The Bottom Line on Dietary Supplements</a>
        </h3>
        <div className="card-body">
            <p>
            One may not need charts and graphs at this point to know that in
            the past couple of years expecially, the buying and selling
            on....
            </p>
            <ul className="list-unstyled d-flex justify-content-between ">
            <li className="d-flex">
                <img
                src="images/post-author.jpg"
                className="object-fit-contain"
                alt=""
                />
                <div className="d-flex flex-column mx-2  ">
                <h5 className="text-dark">John Singleton</h5>
                <span className="text-dark">nutritionist</span>
                </div>
            </li>
            <li>
                {" "}
                <button className="btn btn-outline-success">Read more</button>
            </li>
            </ul>
        </div>
        </div>
    </div>
    <div className="col-lg-4 col-md-6">
        <div className="card border-0 ">
        <img
            src={twotourevents2}
            className="card-img-top"
            alt="..."
        />
        <div className="card-body d-flex ">
            <span className="">
            {" "}
            <i className="fa-regular fa-calendar-days text-success" />{" "}
            SEPTEMBER 19,2022{" "}
            </span>
        </div>
        <h3 className="post-title">
            <a href="#">The Bottom Line on Dietary Supplements</a>
        </h3>
        <div className="card-body">
            <p>
            One may not need charts and graphs at this point to know that in
            the past couple of years expecially, the buying and selling
            on....
            </p>
            <ul className="list-unstyled d-flex justify-content-between ">
            <li className="d-flex">
                <img
                src="images/post-author.jpg"
                className="object-fit-contain"
                alt=""
                />
                <div className="d-flex flex-column mx-2">
                <h5 className="text-dark">John Singleton</h5>
                <span className="text-dark">nutritionist</span>
                </div>
            </li>
            <li>
                {" "}
                <button className="btn btn-outline-success">Read more</button>
            </li>
            </ul>
        </div>
        </div>
    </div>
    <div className="col-lg-4 col-md-6">
        <div className="card border-0 ">
        <img
            src={twotourevents3}
            className="card-img-top"
            alt="..."
        />
        <div className="card-body d-flex ">
            <span className="">
            {" "}
            <i className="fa-regular fa-calendar-days text-success" />{" "}
            SEPTEMBER 19,2022{" "}
            </span>
        </div>
        <h3 className="post-title">
            <a href="#">The Bottom Line on Dietary Supplements</a>
        </h3>
        <div className="card-body">
            <p>
            One may not need charts and graphs at this point to know that in
            the past couple of years expecially, the buying and selling
            on....
            </p>
            <ul className="list-unstyled d-flex justify-content-between ">
            <li className="d-flex">
                <img
                src="images/post-author.jpg"
                className="object-fit-contain"
                alt=""
                />
                <div className="d-flex flex-column mx-2">
                <h5 className="text-dark">John Singleton</h5>
                <span className="text-dark">nutritionist</span>
                </div>
            </li>
            <li>
                {" "}
                <button className="btn btn-outline-success">Read more</button>
            </li>
            </ul>
        </div>
        </div>
    </div>
    </section>
</div>
);
}
